export default {
  SELECT_MULTIPLE: 'selectMultipleRouteStops',
  REQUEST: 'requestModal',
  PICK_REQUEST: 'pickupStopsModal',
  MOVE_TO: 'moveToModal',
  MERGE_STOPS: 'mergeStopsModal',
  TRANSFER_TO: 'transferModal',
  TRANSFER_SUMMARY: 'transferSummaryModal',
  REMOVE: 'removeParcelsModal',
  CLOSE_TOTE: 'closeToteModal',
  PARCELS_INFO: 'parcelsInfoModal',
  RECONSOLIDATION_NOTICE: 'reconsolidationNoticeModal',
};
